/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/merge_frigate_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 11.75v-7.5h-7.5L16 0l-4.25 4.25h-7.5v7.5L0 16l4.25 4.25v7.5h7.5L12 28v4h8v-4l.25-.25h7.5v-7.5L32 16l-4.25-4.25zm-9.141-1.598h1.955v.652h-1.955v-.652zM14.043 9.5h3.914v1.305h-3.914V9.5zm3.914 1.956L16 15.369l-1.957-3.913h3.914zm-6.522-1.304h1.956v.652h-1.956v-.652zm1.956 1.304L16 17.047l2.609-5.591h1.955L16 20.587l-4.565-9.131h1.956zM4.75 4.75h6.5l-6.5 6.5v-6.5zm0 22.5v-6.5l6.5 6.5h-6.5zm7.337-7.968h-.652v-3.908l-1.956-3.918h1.305L16 21.893l5.217-10.437h1.305L16.24 24h-.5l-3.653-7.318v2.6zm4.213 9.004V30h-.6v-4h.6v2.286zm4.264-9.004h-.651v-2.608l.651-1.305v3.913zm6.686 7.968h-6.5l6.5-6.5v6.5zm0-16l-6.5-6.5h6.5v6.5z"/>'
  }
})
